const initSidebar = () => {
    const sidebar = document.querySelector(".sidebar");
    sidebar && sidebar.childNodes.length > 0 && sidebar.childNodes.forEach(child => {
        if (child instanceof HTMLElement) {
            child.getAttribute("data-sidebar-page-id") == document.querySelector("[data-sidebar-active-element-id]").getAttribute("data-sidebar-active-element-id") ? child.classList.add("active") : null;
            child.addEventListener("click", () => {
                sidebar.childNodes.forEach(child => child instanceof HTMLElement && child.classList.remove("active"));
                child.classList.add("active");
            });
        }
    });
};
